import endpoint from "../../config/endpoints";

export const EnquiryStatusJson = {
    showSaveNextBtn: true,
    formPath: "/enquiry-status-form",
    apiBaseURL: endpoint.enquiryStatus,
    changeExcel: endpoint.exportData,
    screenTitle: "Enquiry Status",
    showAddButton: true,
    showPdfDownload: false,
    pdfFileName: "Enquiry Status",
    showExcelDownload: true,
    excelFileName: "Enquiry Status",
    isActiveURL: endpoint.enquiryStatus + "/update-is-active",
    noteValue: 'Enquiry Status',
    tableColumnsToFilter: [
        {
            columnDisplayName: "Enquiry Status Name",
            columnKeyName: "name",
            isChecked: true,
        },
        {
            columnDisplayName: "Status",
            columnKeyName: "isActive",
            isChecked: true,
        },
    ],
    fieldMeta: [
        {
            label: "Enquiry Status Name",
            controlType: "textfield",
            placeHolder: "Name",
            md: 6,
            lg: 6,
            sm: 6,
            xs: 12,
            autoFocus: true,
            dataKey: "name",
            isMandatory: true,
            uniqueValidation: true,
        },
    ],
};